import React, { useState } from 'react';
import { Box, Button, Typography, Alert, CircularProgress } from '@mui/material';
import geocodingService from '../../services/geocodingService';

/**
 * Composant de test pour diagnostiquer les problèmes SSL avec Nominatim
 */
const SSLTestComponent = () => {
  const [testing, setTesting] = useState(false);
  const [results, setResults] = useState([]);

  const runTests = async () => {
    setTesting(true);
    setResults([]);
    
    const testResults = [];

    // Test 1: Recherche d'adresse simple
    try {
      testResults.push({ test: 'Recherche adresse "Paris"', status: 'running' });
      setResults([...testResults]);
      
      const searchResult = await geocodingService.searchAddresses('Paris');
      testResults[testResults.length - 1] = {
        test: 'Recherche adresse "Paris"',
        status: 'success',
        result: `${searchResult.length} résultats trouvés`
      };
    } catch (error) {
      testResults[testResults.length - 1] = {
        test: 'Recherche adresse "Paris"',
        status: 'error',
        error: error.message
      };
    }
    setResults([...testResults]);

    // Test 2: Géocodage inversé
    try {
      testResults.push({ test: 'Géocodage inversé (Paris)', status: 'running' });
      setResults([...testResults]);
      
      const reverseResult = await geocodingService.reverseGeocode(48.8566, 2.3522);
      testResults[testResults.length - 1] = {
        test: 'Géocodage inversé (Paris)',
        status: 'success',
        result: reverseResult ? reverseResult.display_name : 'Aucun résultat'
      };
    } catch (error) {
      testResults[testResults.length - 1] = {
        test: 'Géocodage inversé (Paris)',
        status: 'error',
        error: error.message
      };
    }
    setResults([...testResults]);

    // Test 3: Appel direct fetch
    try {
      testResults.push({ test: 'Test fetch direct HTTPS', status: 'running' });
      setResults([...testResults]);
      
      const response = await fetch('https://nominatim.openstreetmap.org/search?q=Paris&format=json&limit=1');
      const data = await response.json();
      
      testResults[testResults.length - 1] = {
        test: 'Test fetch direct HTTPS',
        status: 'success',
        result: `Status: ${response.status}, Data: ${data.length} résultats`
      };
    } catch (error) {
      testResults[testResults.length - 1] = {
        test: 'Test fetch direct HTTPS',
        status: 'error',
        error: error.message
      };
    }
    setResults([...testResults]);

    setTesting(false);
  };

  return (
    <Box sx={{ p: 3, maxWidth: 600 }}>
      <Typography variant="h6" gutterBottom>
        Test de diagnostic SSL/Nominatim
      </Typography>
      
      <Button 
        variant="contained" 
        onClick={runTests} 
        disabled={testing}
        sx={{ mb: 2 }}
      >
        {testing ? <CircularProgress size={20} sx={{ mr: 1 }} /> : null}
        Lancer les tests
      </Button>

      {results.map((result, index) => (
        <Alert 
          key={index} 
          severity={
            result.status === 'success' ? 'success' : 
            result.status === 'error' ? 'error' : 
            'info'
          }
          sx={{ mb: 1 }}
        >
          <Typography variant="subtitle2">{result.test}</Typography>
          {result.result && <Typography variant="body2">{result.result}</Typography>}
          {result.error && <Typography variant="body2" color="error">{result.error}</Typography>}
        </Alert>
      ))}

      <Alert severity="info" sx={{ mt: 2 }}>
        <Typography variant="body2">
          Ce test vérifie si les problèmes SSL affectent les appels à Nominatim OpenStreetMap.
          Si tous les tests échouent avec des erreurs SSL, le problème vient probablement de la configuration réseau ou des certificats.
        </Typography>
      </Alert>
    </Box>
  );
};

export default SSLTestComponent;
